import store from '@src/store';
import { UPDATE_PAYMENT_START } from '@src/app/accounts/updatepayment/actions';
export const PAYMENTS_START = 'PAYMENTS_START';
export const PAYMENTS_SUCCESS = 'PAYMENTS_SUCCESS';
export const PAYMENTS_ERROR = 'PAYMENTS_ERROR';
export const PAYMENTS_LOADING = 'PAYMENTS_LOADING';
export const PAYMENTS_CANCEL = 'PAYMENTS_CANCEL';

export type Actions = {
    PAYMENTS_START: { type: typeof PAYMENTS_START, payload: any },
    PAYMENTS_LOADING: { type: typeof PAYMENTS_LOADING, payload: boolean },
    PAYMENTS_SUCCESS: { type: typeof PAYMENTS_SUCCESS, payload: any },
    PAYMENTS_ERROR: { type: typeof PAYMENTS_ERROR, payload: any },
    PAYMENTS_CANCEL: { type: typeof PAYMENTS_CANCEL, payload: any },
  };
// Action Creators
export const actionCreators = {
  paymentsStart: (payload: any): Actions[typeof PAYMENTS_START] => ({
    type: PAYMENTS_START, payload,
  }),
  paymentsError: (payload: any): Actions[typeof PAYMENTS_ERROR] => ({
    type: PAYMENTS_ERROR, payload,
  }),
  paymentsSuccess: (payload: any): Actions[typeof PAYMENTS_SUCCESS] => {
    payload.accountResponse.paymentsPayloads.forEach (paymentPayload => {
      if (paymentPayload.autoRenewOptIn ) {
        if (paymentPayload.systemCode === 'SERVPF' && paymentPayload.planCode !== '') {
          // tslint:disable-next-line: no-string-literal
          paymentPayload['googleAnalyticsCategory'] = 'Update Payment Method';
          store.dispatch({type: UPDATE_PAYMENT_START, payload: [paymentPayload]});
        }
      } 
    });
    return ({  type: PAYMENTS_SUCCESS, payload, });
  },
  paymentsLoading: (payload: boolean): Actions[typeof PAYMENTS_LOADING] => ({
    type: PAYMENTS_LOADING, payload,
  }),
  paymentsCancel: (payload: boolean): Actions[typeof PAYMENTS_CANCEL] => ({
    type: PAYMENTS_CANCEL, payload,
  }),
};
